import React, { useState, useEffect } from "react";
import { Button } from "antd";
import Table from "../../../Extracomponents/Table";
import Content from "../../../components/Contents/Content";
import Swal from "sweetalert2";
import {
  ActiveClientsdatewise,
  Activeclientsbydate,
} from "../../../Services/Admin/Admin";
import { fDate } from "../../../../Utils/Date_formate";
import { exportToCSV } from "../../../../Utils/ExportData";
import { Tooltip } from "antd";
import { ArrowDownToLine } from "lucide-react";
import { fDateTime } from "../../../../Utils/Date_formate";

const ActiveClientsDatewise = () => {
  const token = localStorage?.getItem("token");

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const years = [];
  for (let y = 2020; y <= currentYear; y++) {
    years.push(y);
  }

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = async () => {
    if (!month || !year) {
      Swal.fire("Error", "Please select both Month and Year", "error");
      return;
    }

    if (year > currentYear || (year === currentYear && month > currentMonth)) {
      Swal.fire("Error", "You cannot select a future month or year", "error");
      return;
    }

    setLoading(true);
    try {
      const payload = { month: parseInt(month), year: parseInt(year) };
      const response = await ActiveClientsdatewise(payload, token);

      if (response?.status && response?.data && response.data.length > 0) {
        const today = new Date();
        const filtered = response.data.filter(
          (item) => new Date(item.date) <= today
        );
        setData(filtered);
      } else {
        setData([]);
        Swal.fire(
          "No Data",
          response?.message || "No records found for selected month/year",
          "info"
        );
      }
    } catch (err) {
      console.error(err);
      setData([]);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const getexportfile = async (row) => {
    try {
      const data = {
        date: row?.date,
      };

      const response = await Activeclientsbydate(data, token);
      let csvArr = [];

      if (response.data?.length > 0) {
        csvArr = response.data.map((item) => {
          return {
            Name: item?.client?.FullName || "N/A",
            Pan: item?.client?.panno || "N/A",
            Email: item?.client?.Email || "N/A",
            DateOfAgreement: item?.client?.kyc_agreement_date
              ? fDateTime(item.client.kyc_agreement_date)
              : "N/A",

            Address:
              [item?.client?.state, item?.client?.city]
                .filter(Boolean)
                .join(", ") || "N/A",
            Fees: item?.total_sum || 0,
            PlanName: item?.plan_titles?.join(", ") || "N/A",
            StartDate: fDateTime(item?.min_plan_start) || "N/A",
            EndDate: fDateTime(item?.max_plan_end) || "N/A",
          };
        });

        console.log("csvArr", csvArr);
      } else {
        console.error("No data available.");
        return;
      }

      exportToCSV(csvArr, "All Clients");
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "100px",
      center: true,
    },
    {
      name: "Date",
      selector: (row) => fDate(row.date),
      sortable: true,
    },
    {
      name: "Active Clients",
      selector: (row) => row.activeClients,
      sortable: true,
      center: true,
    },
    {
      name: "Client List",
      selector: (row) => (
        <div
          style={{ color: "green", cursor: "pointer" }}
          onClick={() => getexportfile(row)}
        >
          <Tooltip placement="top" overlay="Download">
            <ArrowDownToLine />
          </Tooltip>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
  ];

  return (
    <Content
      Page_title="Active Clients (Date Wise)"
      button_status={false}
      backbutton_status={true}
      backForword={true}
    >
      <div className="page-content">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-3">
                <label className="form-label">Month</label>
                <select
                  className="form-control"
                  value={month}
                  onChange={(e) => setMonth(parseInt(e.target.value))}
                  style={{ width: "100%" }}
                >
                  {months.map((m) => (
                    <option
                      key={m.value}
                      value={m.value}
                      disabled={year === currentYear && m.value > currentMonth}
                    >
                      {m.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">Year</label>
                <select
                  className="form-control"
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value))}
                  style={{ width: "100%" }}
                >
                  {years.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3 d-flex align-items-end">
                <Button
                  type="primary"
                  onClick={handleSearch}
                  loading={loading}
                  style={{ width: "100%" }}
                >
                  Search
                </Button>
              </div>
            </div>

            <div className="table-responsive">
              <Table columns={columns} data={data} />
            </div>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default ActiveClientsDatewise;
